<!-- <a routerLink="/dashboard" >Menu-1</a> |  
<a routerLink="/myaccount" >Menu-2</a> |  
<a routerLink="/group" >Menu-3</a>   -->
<ngx-loading-bar [includeSpinner]="false" height="3px" [color]="'#d3462f'"></ngx-loading-bar>
<router-outlet></router-outlet>  